import React from 'react';
import Svg, { Circle } from 'react-native-svg';

export interface BulletIconProps {
  /** Can be used to change the color of the icon. You can use any VXL color.  */
  iconColor?: string;

  /** The size of the icon */
  iconSize?: number;

  /** The accessibility label for the bullet icon. */
  iconAccessibilityLabel?: string;
}

export default function Bullet({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: BulletIconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 13 12"
    >
      <Circle cx="6.5" cy="6.00012" r="5.5" fill={iconColor} />
    </Svg>
  );
}
